import { render, staticRenderFns } from "./CartProducts.vue?vue&type=template&id=23111ee3&"
import script from "./CartProducts.vue?vue&type=script&lang=js&"
export * from "./CartProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports